import Tooltip from "@mui/material/Tooltip";
import React from "react";

import { useToggle } from "react-use";
import Remove from "shared/assets/images/svg/remove_red.svg";
import Input from "shared/component/inputFields";
import { useCreateOrder } from "customer/orders/create-order/create-order.service";
import { localize } from "shared/helpers/utils";

const NewOrder = (props) => {
  const { newOrderForm, setOrderData, pickPoints, deliveryPoints, serviceTypes } = useCreateOrder();
  const {
    register,
    setValue,
    control,
    formState: { errors },
    handleSubmit,
  } = newOrderForm;
  const [show, toggle] = useToggle(false);

  const next = (data) => {
    setOrderData((d) => ({ ...d, ...data }));
   props.nextStep();
  };

  return (
    <form onSubmit={handleSubmit(next)} className="myorder newOrder">
      <div className="container">
        <div className="steps">
          <Tooltip title="NEW ORDER" arrow>
            <span className="indicator active"></span>
          </Tooltip>
          <Tooltip title="SHIPPING DETAILS" arrow>
            <span className="indicator"></span>
          </Tooltip>
          <Tooltip title="FROM DETAILS" arrow>
            <span className="indicator"></span>
          </Tooltip>
          <Tooltip title="TO DETAILS" arrow>
            <span className="indicator"></span>
          </Tooltip>
          <Tooltip title="DESTINATIONS" arrow>
            <span className="indicator"></span>
          </Tooltip>
          <Tooltip title="SUMMARY" arrow>
            <span className="indicator"></span>
          </Tooltip>
          <Tooltip title="PENDING" arrow>
            <span className="indicator"></span>
          </Tooltip>
        </div>

        <div className="box-order">
          <div className="order-header">
            <h1 className="title">NEW ORDER</h1>
            <hr className="hr" />
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Input
                {...register("pickPoint")}

                error={errors.pickPoint?.message}
                type="select"
                label="Pickup Point:"
                options={pickPoints?.data}
                getOptionLabel={(a) => localize(a.addressName)}
              />
            </div>
            <div className="col-lg-4">
              <Input
                error={errors.deliveryPoint?.message}
                {...register("deliveryPoint")}
                type="select"
                label="Delivery Point:"
                options={deliveryPoints?.data}
                getOptionLabel={(a) => localize(a.addressName)}
              />
            </div>
            <div className="col-lg-4">
              <Input
                error={errors.shippingDate?.message}
                onValueChange={(date) => setValue("shippingDate", date, { shouldValidate: true })}
                type="date"
                label="Shipping Date:"
              />
            </div>
            <div className="col-lg-4">
              <Input
                error={errors.serviceType?.message}
                {...register("serviceType")}
                type="select"
                label="Service Type:"
                options={serviceTypes}
                getOptionLabel={(s) => localize(s.name)}
              />
            </div>
          </div>
          <hr className="hr mt-14" />
          <div className="sect-2">
            <label htmlFor="multiple" className="multiple">
              <input type="checkbox" id="multiple" onClick={toggle} />
              <span>Multiple Destinations</span>
            </label>
            {show && <button className="btn-green">+ Add Another</button>}
          </div>
          {show && (
            <div className="all-stops">
              <div className="stops">
                <div className="stops-header">
                  <h1 className="title">Stop No. 1</h1>
                  <img className="remove" src={Remove} alt="Remove" />
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Input type="text" label="Pickup Point:" value="Cairo" dashed />
                  </div>
                  <div className="col-md-6">
                    <Input type="select" label="To:" />
                  </div>
                </div>
              </div>
              <div className="stops">
                <div className="stops-header">
                  <h1 className="title">Stop No. 2</h1>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Input type="text" label="From: " value="Tanta" dashed />
                  </div>
                  <div className="col-md-6">
                    <Input type="select" label="Delivery Point:" />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-md-4">
              <button type='submit' className="btn-blue ">
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default NewOrder;
